import { useState } from 'react';
import WinterForm from '../+request/sections/WinterForm';
const RewinterizationModal = ({ isOpen = true, onClose = () => { } }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    if (!isOpen)
        return null;
    return (<div className="fixed inset-0 bg-gray-600 bg-opacity-50 z-50 overflow-y-auto h-full w-full flex items-start justify-center pt-8">
        <div className="bg-white border-4 border-yellow-500 p-8 max-w-4xl w-full mx-4 max-h-[90vh] flex flex-col">
            <div className="flex justify-between items-center mb-6 sticky top-0 bg-white z-10 pb-4">
                <h2 className="text-2xl md:text-4xl text-yellow-500 uppercase font-bold">Please Schedule Your Rewinterization</h2>
                <button onClick={onClose} disabled={isSubmitting} className="text-2xl font-bold text-gray-500 hover:text-gray-700 disabled:opacity-50">×</button>
            </div>
            <div className="flex-1 overflow-y-auto">
                <WinterForm modalMode={true} onSuccess={() => setIsSubmitting(false)} onSubmitting={() => setIsSubmitting(true)} onFailure={() => setIsSubmitting(false)} />
            </div>
        </div>
    </div>);
};
export default RewinterizationModal;
